/* Animalsy – entrega estimada dinámica (metacampo animalsy.dias_entrega)
   - Cuenta en días laborables, zona horaria Europe/Madrid
   - Pedidos antes de la hora de corte salen hoy (si es laborable)
   - Rango: dias-1 .. dias+1 (mínimo 1) */
(function () {
  if (window.customElements.get('anm-delivery')) return;

  var TZ = 'Europe/Madrid';
  // Festivos nacionales de fecha fija (MM-DD)
  var FIXED = ['01-01', '01-06', '05-01', '08-15', '10-12', '11-01', '12-06', '12-08', '12-25'];
  // Festivos móviles (Viernes Santo)
  var MOVABLE = ['2026-04-03', '2027-03-26', '2028-04-14', '2029-03-30'];

  function nowMadrid() {
    var p = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { date: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), h: +p.hour, m: +p.minute };
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function nextDay(d) { return new Date(d.getTime() + 86400000); }
  function isWorkday(d, extra) {
    var w = d.getUTCDay();
    if (w === 0 || w === 6) return false;
    var s = iso(d);
    return FIXED.indexOf(s.slice(5)) === -1 && MOVABLE.indexOf(s) === -1 && extra.indexOf(s) === -1;
  }
  function addWorkdays(d, n, extra) {
    var x = d;
    while (n > 0) { x = nextDay(x); if (isWorkday(x, extra)) n--; }
    return x;
  }
  var fmt = new Intl.DateTimeFormat('es-ES', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' });
  function parts(d) {
    var o = {};
    fmt.formatToParts(d).forEach(function (x) { o[x.type] = x.value.replace('.', ''); });
    return { wd: o.weekday, day: o.day, mon: o.month };
  }

  class AnmDelivery extends HTMLElement {
    connectedCallback() {
      this.render();
      if (this.dataset.style === 'full' && !this._timer) {
        this._timer = setInterval(this.render.bind(this), 60000);
      }
    }
    disconnectedCallback() { clearInterval(this._timer); this._timer = null; }
    render() {
      var text = this.querySelector('.anm-delivery__text');
      if (!text) return;
      var days = Math.max(1, parseInt(this.dataset.days, 10) || 2);
      var cutoff = parseInt(this.dataset.cutoff, 10);
      if (isNaN(cutoff)) cutoff = 19;
      var extra = (this.dataset.holidays || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);

      var now = nowMadrid();
      var today = now.date;
      var shipsToday = isWorkday(today, extra) && now.h < cutoff;
      var ship = shipsToday ? today : addWorkdays(today, 1, extra);
      var dMin = addWorkdays(ship, Math.max(1, days - 1), extra);
      var dMax = addWorkdays(ship, days + 1, extra);

      var a = parts(dMin);
      var b = parts(dMax);
      var sameMonth = a.mon === b.mon;
      var html;

      if (this.dataset.style === 'full') {
        var start = a.wd + ' ' + a.day + (sameMonth ? '' : ' de ' + a.mon);
        var end = b.wd + ' ' + b.day + ' de ' + b.mon;
        html = 'Recíbelo entre el <strong>' + start + '</strong> y el <strong>' + end + '</strong>';
        if (shipsToday) {
          var left = cutoff * 60 - (now.h * 60 + now.m);
          var h = Math.floor(left / 60);
          var m = left % 60;
          var t = (h > 0 ? h + ' h ' : '') + m + ' min';
          html += '<span class="anm-delivery__sub">Pide en las próximas <strong>' + t + '</strong> y sale hoy</span>';
        } else {
          var s = parts(ship);
          html += '<span class="anm-delivery__sub">Si lo pides ahora, sale el ' + s.wd + ' ' + s.day + ' de ' + s.mon + '</span>';
        }
      } else {
        var startC = a.wd + ' ' + a.day + (sameMonth ? '' : ' ' + a.mon);
        html = 'Entrega <strong>' + startC + ' – ' + b.wd + ' ' + b.day + ' ' + b.mon + '</strong>';
      }
      text.innerHTML = html;
      this.classList.add('is-ready');
    }
  }
  window.customElements.define('anm-delivery', AnmDelivery);
})();
